<script>
    import UserSearchHeader from '@/components/page-user-edit/user-search/UserSearchHeader.vue';
    import UserSearchData from '@/components/page-user-edit/user-search/UserSearchData.vue';

    export default {
        computed: {
            isShowUserSearch() {return this.$store.getters.IS_SHOW_USER_SEARCH}
        },
        components: {
            UserSearchHeader: UserSearchHeader,
            UserSearchData: UserSearchData,
        }
    }
</script>


<template>
    <div
        v-if="isShowUserSearch"
        class="left_additional_container"
    >
        <UserSearchHeader />
        <hr class="hr_light_98">
        <UserSearchData />
    </div>
</template>